import { OrderDirection } from "_shared/_api/ordering/order-direction";
import { OrderParameters } from "_shared/_api/queries/ordering/order-parameters";

export enum FeeScheduleTemplateOrderField {
  Name = "Name",
  CreatedDate = "CreatedDate",
  Tags = "Tags",
}

export class FeeScheduleTemplateOrderParameters extends OrderParameters {
  public static fromSearchParams(
    searchParams: URLSearchParams,
    options?: {
      orderByParamName: string;
      orderDirParamName: string;
    }
  ): FeeScheduleTemplateOrderParameters {
    const opts = options ?? {
      orderByParamName: "orderBy",
      orderDirParamName: "orderDir",
    };

    let orderBy = FeeScheduleTemplateOrderField.CreatedDate;
    let orderDir = OrderDirection.Descending;

    const orderByParam = searchParams.get(opts.orderByParamName);
    const orderDirParam = searchParams.get(opts.orderDirParamName);

    if (orderByParam) {
      const enumValue = Object.values(FeeScheduleTemplateOrderField).find(
        (field) => field.toLowerCase() === orderByParam.toLowerCase()
      );
      if (enumValue) {
        orderBy = enumValue;
      }
    }

    if (orderDirParam) {
      const enumValue = Object.values(OrderDirection).find(
        (field) => field.toLowerCase() === orderDirParam.toLowerCase()
      );
      if (enumValue) {
        orderDir = enumValue;
      }
    }

    return new FeeScheduleTemplateOrderParameters({
      orderBy,
      orderDir,
    });
  }

  public orderBy: FeeScheduleTemplateOrderField;
  public orderDir: OrderDirection;

  constructor(params: { orderBy: FeeScheduleTemplateOrderField; orderDir: OrderDirection }) {
    super();
    const { orderBy, orderDir } = params;
    this.orderBy = orderBy;
    this.orderDir = orderDir;
  }

  public isEqualTo(other: FeeScheduleTemplateOrderParameters): boolean {
    if (!other || !(other instanceof FeeScheduleTemplateOrderParameters)) return false;
    return this.orderBy === other.orderBy && this.orderDir === other.orderDir;
  }
}
